// Placement categories for grouping
export const PLACEMENT_CATEGORIES = {
    FEED: 'Feed',
    STORIES: 'Stories',
    REELS: 'Reels',
    SEARCH: 'Search',
    DISPLAY: 'Display',
    VIDEO: 'Video',
    SHOPPING: 'Shopping',
    OTHER: 'Other'
};

// Meta (Facebook/Instagram) placements
export const META_PLACEMENTS = {
    // Facebook placements
    'facebook_feed': { name: 'Facebook Feed', category: PLACEMENT_CATEGORIES.FEED, icon: '📱', platform: 'facebook' },
    'facebook_stories': { name: 'Facebook Stories', category: PLACEMENT_CATEGORIES.STORIES, icon: '📖', platform: 'facebook' },
    'facebook_reels': { name: 'Facebook Reels', category: PLACEMENT_CATEGORIES.REELS, icon: '🎬', platform: 'facebook' },
    'facebook_marketplace': { name: 'Facebook Marketplace', category: PLACEMENT_CATEGORIES.SHOPPING, icon: '🛒', platform: 'facebook' },
    'facebook_right_column': { name: 'Facebook Right Column', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '📊', platform: 'facebook' },
    'facebook_video_feeds': { name: 'Facebook Video Feeds', category: PLACEMENT_CATEGORIES.VIDEO, icon: '▶️', platform: 'facebook' },
    'facebook_instant_article': { name: 'Facebook Instant Articles', category: PLACEMENT_CATEGORIES.FEED, icon: '📰', platform: 'facebook' },
    'facebook_instream_video': { name: 'Facebook In-Stream Video', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🎥', platform: 'facebook' },
    'facebook_search': { name: 'Facebook Search Results', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔍', platform: 'facebook' },

    // Instagram placements
    'instagram_feed': { name: 'Instagram Feed', category: PLACEMENT_CATEGORIES.FEED, icon: '📸', platform: 'instagram' },
    'instagram_stories': { name: 'Instagram Stories', category: PLACEMENT_CATEGORIES.STORIES, icon: '📖', platform: 'instagram' },
    'instagram_reels': { name: 'Instagram Reels', category: PLACEMENT_CATEGORIES.REELS, icon: '🎬', platform: 'instagram' },
    'instagram_explore': { name: 'Instagram Explore', category: PLACEMENT_CATEGORIES.FEED, icon: '🔍', platform: 'instagram' },
    'instagram_explore_home': { name: 'Instagram Explore Home', category: PLACEMENT_CATEGORIES.FEED, icon: '🏠', platform: 'instagram' },
    'instagram_profile_feed': { name: 'Instagram Profile Feed', category: PLACEMENT_CATEGORIES.FEED, icon: '👤', platform: 'instagram' },
    'instagram_shop': { name: 'Instagram Shop', category: PLACEMENT_CATEGORIES.SHOPPING, icon: '🛍️', platform: 'instagram' },
    'instagram_igtv': { name: 'Instagram IGTV', category: PLACEMENT_CATEGORIES.VIDEO, icon: '📺', platform: 'instagram' },

    // Messenger placements
    'messenger_inbox': { name: 'Messenger Inbox', category: PLACEMENT_CATEGORIES.OTHER, icon: '💬', platform: 'messenger' },
    'messenger_stories': { name: 'Messenger Stories', category: PLACEMENT_CATEGORIES.STORIES, icon: '📖', platform: 'messenger' },
    'messenger_sponsored_messages': { name: 'Messenger Sponsored Messages', category: PLACEMENT_CATEGORIES.OTHER, icon: '✉️', platform: 'messenger' },

    // Audience Network placements
    'audience_network_classic': { name: 'Audience Network Classic', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '🌐', platform: 'audience_network' },
    'audience_network_instream_video': { name: 'Audience Network In-Stream Video', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🎥', platform: 'audience_network' },
    'audience_network_rewarded_video': { name: 'Audience Network Rewarded Video', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🎁', platform: 'audience_network' }
};

// Google Ads placements
export const GOOGLE_PLACEMENTS = {
    'search': { name: 'Search Network', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔍', platform: 'google_search' },
    'search_partners': { name: 'Search Partners', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔎', platform: 'google_search' },
    'display': { name: 'Display Network', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '🖼️', platform: 'google_display' },
    'youtube_watch': { name: 'YouTube Watch', category: PLACEMENT_CATEGORIES.VIDEO, icon: '▶️', platform: 'youtube' },
    'youtube_search': { name: 'YouTube Search', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔍', platform: 'youtube' },
    'youtube_shorts': { name: 'YouTube Shorts', category: PLACEMENT_CATEGORIES.REELS, icon: '📱', platform: 'youtube' },
    'youtube_home': { name: 'YouTube Home Feed', category: PLACEMENT_CATEGORIES.FEED, icon: '🏠', platform: 'youtube' },
    'discovery': { name: 'Discovery', category: PLACEMENT_CATEGORIES.FEED, icon: '💡', platform: 'google_discovery' },
    'gmail': { name: 'Gmail', category: PLACEMENT_CATEGORIES.OTHER, icon: '✉️', platform: 'gmail' },
    'shopping': { name: 'Shopping', category: PLACEMENT_CATEGORIES.SHOPPING, icon: '🛍️', platform: 'google_shopping' },
    'performance_max': { name: 'Performance Max', category: PLACEMENT_CATEGORIES.OTHER, icon: '⚡', platform: 'google_pmax' }
};

// TikTok placements
export const TIKTOK_PLACEMENTS = {
    'tiktok_feed': { name: 'TikTok For You Feed', category: PLACEMENT_CATEGORIES.FEED, icon: '🎵', platform: 'tiktok' },
    'tiktok_topview': { name: 'TikTok TopView', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🔝', platform: 'tiktok' },
    'tiktok_search': { name: 'TikTok Search Results', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔍', platform: 'tiktok' },
    'tiktok_profile': { name: 'TikTok Profile', category: PLACEMENT_CATEGORIES.FEED, icon: '👤', platform: 'tiktok' },
    'pangle_app': { name: 'Pangle (In-App)', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '📱', platform: 'pangle' },
    'pangle_rewarded': { name: 'Pangle Rewarded Video', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🎁', platform: 'pangle' },
    'news_feed': { name: 'News Feed Apps', category: PLACEMENT_CATEGORIES.FEED, icon: '📰', platform: 'tiktok_news' }
};

// Amazon placements
export const AMAZON_PLACEMENTS = {
    'top_of_search': { name: 'Top of Search', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔝', platform: 'amazon' },
    'rest_of_search': { name: 'Rest of Search', category: PLACEMENT_CATEGORIES.SEARCH, icon: '🔍', platform: 'amazon' },
    'product_pages': { name: 'Product Pages', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '📦', platform: 'amazon' },
    'brand_store': { name: 'Brand Store', category: PLACEMENT_CATEGORIES.SHOPPING, icon: '🏪', platform: 'amazon' },
    'video': { name: 'Sponsored Video', category: PLACEMENT_CATEGORIES.VIDEO, icon: '🎬', platform: 'amazon' },
    'display': { name: 'Sponsored Display', category: PLACEMENT_CATEGORIES.DISPLAY, icon: '🖼️', platform: 'amazon' }
};

// Get all placements for a platform
export const getPlacementsForPlatform = (platform) => {
    switch (platform) {
        case 'meta':
            return META_PLACEMENTS;
        case 'google':
            return GOOGLE_PLACEMENTS;
        case 'tiktok':
            return TIKTOK_PLACEMENTS;
        case 'amazon':
            return AMAZON_PLACEMENTS;
        default:
            return {};
    }
};

// Normalize Meta API placement response to our placement IDs
export const normalizeMetaPlacement = (publisherPlatform, platformPosition) => {
    // Map Meta API values to our placement IDs
    const platform = (publisherPlatform || '').toLowerCase();
    const position = (platformPosition || '').toLowerCase().replace(/\s+/g, '_');

    // Build placement ID
    const placementId = `${platform}_${position}`;

    // Check if we have this placement defined
    if (META_PLACEMENTS[placementId]) {
        return placementId;
    }

    // Fallback mappings for common variations
    const fallbackMappings = {
        'facebook_news_feed': 'facebook_feed',
        'instagram_stream': 'instagram_feed',
        'an_classic': 'audience_network_classic',
        'an_instream_video': 'audience_network_instream_video'
    };

    if (fallbackMappings[placementId]) {
        return fallbackMappings[placementId];
    }

    // Return the generated ID even if not in our list (for future placements)
    return placementId;
};

// Normalize Google Ads placement
export const normalizeGooglePlacement = (adNetworkType) => {
    const mappings = {
        'SEARCH': 'search',
        'SEARCH_PARTNERS': 'search_partners',
        'CONTENT': 'display',
        'YOUTUBE_SEARCH': 'youtube_search',
        'YOUTUBE_WATCH': 'youtube_watch',
        'MIXED': 'performance_max'
    };
    return mappings[adNetworkType] || adNetworkType?.toLowerCase() || 'other';
};

// Normalize TikTok placement
export const normalizeTikTokPlacement = (placement) => {
    const mappings = {
        'TikTok': 'tiktok_feed',
        'Pangle': 'pangle_app',
        'TopBuzz': 'news_feed',
        'BuzzVideo': 'news_feed'
    };
    return mappings[placement] || placement?.toLowerCase().replace(/\s+/g, '_') || 'tiktok_feed';
};

// Normalize Amazon placement
export const normalizeAmazonPlacement = (placement) => {
    const mappings = {
        'Top of Search (first page)': 'top_of_search',
        'Rest of search': 'rest_of_search',
        'Product page': 'product_pages',
        'Other': 'display'
    };
    return mappings[placement] || placement?.toLowerCase().replace(/\s+/g, '_') || 'product_pages';
};

// Get placement info by ID and platform
export const getPlacementInfo = (placementId, platform) => {
    const placements = getPlacementsForPlatform(platform);
    return placements[placementId] || {
        name: placementId.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        category: PLACEMENT_CATEGORIES.OTHER,
        icon: '📍',
        platform: platform
    };
};

// Group placements by category
export const groupPlacementsByCategory = (placementData) => {
    const grouped = {};

    placementData.forEach(item => {
        const category = item.category || PLACEMENT_CATEGORIES.OTHER;
        if (!grouped[category]) {
            grouped[category] = {
                name: category,
                placements: [],
                metrics: {
                    spend: 0,
                    impressions: 0,
                    clicks: 0,
                    revenue: 0,
                    roas: 0,
                    ctr: 0
                }
            };
        }
        grouped[category].placements.push(item);

        // Aggregate metrics
        const m = item.metrics || {};
        grouped[category].metrics.spend += m.spend || 0;
        grouped[category].metrics.impressions += m.impressions || 0;
        grouped[category].metrics.clicks += m.clicks || 0;
        grouped[category].metrics.revenue += m.revenue || 0;
    });

    // Calculate derived metrics for each category
    Object.values(grouped).forEach(cat => {
        if (cat.metrics.spend > 0) {
            cat.metrics.roas = cat.metrics.revenue / cat.metrics.spend;
        }
        if (cat.metrics.impressions > 0) {
            cat.metrics.ctr = (cat.metrics.clicks / cat.metrics.impressions) * 100;
        }
    });

    return grouped;
};

// Category icons for UI
export const CATEGORY_ICONS = {
    [PLACEMENT_CATEGORIES.FEED]: '📱',
    [PLACEMENT_CATEGORIES.STORIES]: '📖',
    [PLACEMENT_CATEGORIES.REELS]: '🎬',
    [PLACEMENT_CATEGORIES.SEARCH]: '🔍',
    [PLACEMENT_CATEGORIES.DISPLAY]: '🖼️',
    [PLACEMENT_CATEGORIES.VIDEO]: '▶️',
    [PLACEMENT_CATEGORIES.SHOPPING]: '🛍️',
    [PLACEMENT_CATEGORIES.OTHER]: '📍'
};

// Category order for consistent display
export const CATEGORY_ORDER = [
    PLACEMENT_CATEGORIES.FEED,
    PLACEMENT_CATEGORIES.STORIES,
    PLACEMENT_CATEGORIES.REELS,
    PLACEMENT_CATEGORIES.VIDEO,
    PLACEMENT_CATEGORIES.SEARCH,
    PLACEMENT_CATEGORIES.DISPLAY,
    PLACEMENT_CATEGORIES.SHOPPING,
    PLACEMENT_CATEGORIES.OTHER
];
